import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { faqsResourceDefinition } from 'dpl/breeder_search_results/utils/queryDefinitions';
import useResourceQuery from 'dpl/shared/fetching/hooks/useResourceQuery';
import ClampedMultiLineText from 'dpl/common/components/ClampedMultiLineText';
import { isLessThanBreakpoint } from 'dpl/util/grid';

const IS_LT_MD = isLessThanBreakpoint('md');

export default function FAQModule({ className, breedId, citySlug }) {
  const {
    value: { data: questions }
  } = useResourceQuery(faqsResourceDefinition(breedId, citySlug));

  if (questions.length === 0) return null;

  return (
    <div className={classnames('FAQModule', className)}>
      <h5 className="font-20 md:font-32 lg:font-40 mb2 mb4-md mb6-lg lh-title">
        Frequently asked questions
      </h5>
      <ol style={{ maxWidth: '844px' }}>
        {questions.map(({ question, answer }, index) => (
          <li
            key={index}
            className={classnames({ 'bt b--default': index > 0 })}
          >
            <div className="pv6 pv8-md">
              <h6 className="font-16 md:font-24 font-sans sm:font-sans md:font-serif fw-medium lh-title mb3">
                {question}
              </h6>
              <ClampedMultiLineText
                className="font-16 md:font-18 lh-title secondary"
                lessText="Read less"
                lineHeight={IS_LT_MD ? 20 : 24}
                moreButtonClassName="midnight"
                moreText="Read more"
                numOfLines={IS_LT_MD ? 3 : 2}
                text={answer}
                fadeToButton
                setInnerHTML
                isOpen
              />
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
}

FAQModule.propTypes = {
  breedId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  citySlug: PropTypes.string.isRequired,
  className: PropTypes.string
};

FAQModule.defaultProps = {
  className: null
};
